/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedModule } from '../../shared/shared.module';

@Component({
  selector: 'app-alert',
  imports: [SharedModule],
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent {
  data: any;
  type: string;
  imagePath = '';
  submitLabel = '';
  cancelLabel = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    public dialogRef: MatDialogRef<AlertComponent>
  ) {
    this.type = dialogData.type;
    this.data = dialogData.data;
    this.cancelLabel = dialogData.data.rightButton;
    this.submitLabel = dialogData.data.leftButton;
    this.imagePath = dialogData.imagePath;
  }

  onSubmitClick(): void {
    this.dialogRef.close({ key: true });
  }

  onCancelClick(): void {
    this.dialogRef.close({ key: false });
  }

  onBtnSuccess() {
    this.dialogRef.close({ key: true });
  }
}
